"use client"

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import "@/src/extensions/number"
import "@/src/extensions/string"
import Answer from './answer/answer'
import { useCurrentProduct } from '@/src/context/product/current-product-context'
import ItemInfos from '@/src/interfaces/catalog/item-infos'

interface Props {
    sizeDetails?: ItemInfos.DetailedResponse
}

export default function Group(props: Props) {
    const { currentProduct } = useCurrentProduct()

    const [productDetails, setProductDetails] = useState<ItemInfos.DetailedResponse>()

    const renderSubtitleQuestion = (group: ItemInfos.ItemGroup): string => {
        let message: string = ""

        if (!group.isRequired)
            message = "Opcional"

        if (group.groupingType === 'Combo')
            message = 'Escolha 1 opção'

        if (group.minQtyAnswer > 0 || (group.maxQtyAnswer && group.maxQtyAnswer > 0)) {
            message += `${!group.isRequired ? ' - ' : ''}Escolha `
            message += getMinMaxLabel(group.minQtyAnswer, group.maxQtyAnswer)
        }

        if (group.minQtyItems > 0 || group.maxQtyItems > 0) {
            if (!message.isNullOrEmpty())
                message += ' totalizando '
            else
                message += `${!group.isRequired ? ' - ' : ''}Adicione `

            message += getMinMaxLabel(group.minQtyItems, group.maxQtyItems, true)
        }

        return message
    }

    const getMinMaxLabel = (min: number, max?: number, itemsWord?: boolean) => {
        let message = ""
        let opMin = ""

        const label = itemsWord ? 'item' : 'opção'
        const labelPlural = itemsWord ? 'itens' : 'opções'

        if (min > 0)
            opMin = min == 1 ? label : labelPlural

        let opMax = ""

        if (max && max > 0)
            opMax = max == 1 ? label : labelPlural

        if (min == max)
            message += `${min} ${opMin}`
        else if (max === undefined || max == 0)
            message += `no mínimo ${min} ${opMin}`
        else if (min > 0 && (max > min))
            message += `entre ${min} e ${max} ${opMax}`
        else
            message += `até ${max} ${opMax}`

        return message
    }

    useEffect(() => {
        if (props.sizeDetails)
            setProductDetails(props.sizeDetails)
        else
            setProductDetails(currentProduct)
    }, [props.sizeDetails, currentProduct])

    return (
        <div className={styles.contentRequiredQuestion}>
            {
                productDetails?.itemGroups && productDetails.itemGroups.sort((a, b) => a.sortIndex - b.sortIndex).map((itemGroup, index) => (
                    <div className={styles.container} id={itemGroup.id} key={index}>
                        <div className={`${styles.dataOrdering} scroll-referrer`} data-ordering={index} />
                        <div className={styles.contentHeader}>
                            <div className={styles.contentTitle}>
                                <b className={`font-xmd`}>{itemGroup.groupingType !== 'Combo' ? itemGroup.description : itemGroup.name}</b>
                                <small id={`sub-${itemGroup.id}`} className={`font-md ${styles.info}`}>
                                    {renderSubtitleQuestion(itemGroup)}
                                </small>
                            </div>
                            {
                                itemGroup.isRequired &&
                                <label className={`font-xsm ${styles.requiredLabel}`}>Obrigatório</label>
                            }
                        </div>
                        <div className={styles.contentAnswers}>
                            {
                                itemGroup.itemOptionsGroup.sort((a, b) => a.sortIndex - b.sortIndex).map((option, index) => (
                                    <Answer
                                        key={index}
                                        itemGroup={itemGroup}
                                        itemOption={option}
                                    />
                                ))
                            }
                        </div>
                    </div>
                ))
            }
        </div>
    )
}
